import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='fixed-variable-annuities-faq'
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}
        xlarge={10}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about fixed and variable annuities&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-fixed-variable-annuities'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'fixed-variable-annuities-what-is-it',
              title: <>Who are fixed and variable <WidowBlock>annuities for&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Fixed and variable deferred annuities are a great option for anyone who wants to save more for their retirement. Fixed annuities are a good choice if you&#39;re 5 to 10 years away from retirement. It&#39;s a safe way to grow your money without risking your initial investment. Variable annuities, on the other hand, can be a smart move if you&#39;re closer to retirement, or if you&#39;re younger. That&#39;s because there are a range of investment options that can match your situation and risk tolerance. See how{' '}
                  <Link
                    id='fixed-variable-annuities-what-is-it-link'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'
                    ariaLabel='Talk to an advisor about fixed and variable annuities.'>
                    your advisor
                  </Link>
                  {' '}can help you create a{' '}
                  <Link
                    id='fixed-variable-annuities-retirement-planning-link'
                    linkUrl='/retirement-planning/'
                    variant='primaryDeemphasize'
                    ariaLabel='Learn more about retirement planning with a Northwestern Mutual advisor.'>
                    retirement plan
                  </Link>
                  {' '}with the right annuity for you.
                </Typography>
              ),
            },
            {
              id:'fixed-variable-annuities-why-do-i-need-it',
              title: <>Why should I get an annuity if I have a 401(k) and &#47;or <WidowBlock>an IRA&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Saving in a{' '}
                  <Link
                    id='fixed-variable-annuities-401k-plan-link'
                    linkUrl='/401k-plans/'
                    variant='primaryDeemphasize'
                    ariaLabel='Create a 401(k) plan with an advisor from Northwestern Mutual.'>
                    401(k)
                  </Link>
                  {' '}and taking advantage of your employer&#39;s match is a smart move. But both 401(k)s and{' '}
                  <Link
                    id='fixed-variable-annuities-iras-plan-link'
                    linkUrl='/iras-and-retirement-plans/'
                    variant='primaryDeemphasize'
                    ariaLabel='Create an IRA plan with an advisor from Northwestern Mutual.'>
                    IRAs
                  </Link>
                  {' '}have caps on how much you can contribute annually. Annuities are another way to save for retirement without limits on how much you can contribute. Ask your advisor for more details.{' '}
                  <Link
                    id='fixed-variable-annuities-why-do-i-need-it-link'
                    linkUrl='/find-a-financial-advisor/'
                    variant='primaryDeemphasize'
                    ariaLabel='Connect with a financial advisor about fixed variable annuities.'>
                    Get matched today
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'fixed-variable-annuities-work-coverage',
              title: <>What is a <WidowBlock>variable annuity&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Variable annuities are long&#45;term investments that can help you save money for retirement. The money you put into them grows tax&#45;deferred, like with an IRA or a 401(k). They have multiple investment options, which you can choose from. There are no limits on non&#45;qualified contributions, so when you take money out down the road, only your earnings are taxed as income. When you&#39;re ready to take your money out, you&#39;ll have a few options. You can convert it into a guaranteed, lifelong{' '}
                  <Link
                    id='fixed-variable-annuities-lifelong-income-annuity-link'
                    linkUrl='/annuities/'
                    variant='primaryDeemphasize'
                    ariaLabel='Learn how annuities work as part of a financial plan'>
                    income annuity
                  </Link>, or you can take your money in one lump sum.{' '}
                  <Link
                    id='fixed-variable-annuities-work-coverage-link'
                    linkUrl='/life-and-money/how-do-variable-annuities-work/'
                    variant='primaryDeemphasize'
                    ariaLabel='Learn more about how variable annuities work'>
                    Find out more about how variable annuities work
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'fixed-variable-annuities-social-security',
              title: <>What is a <WidowBlock>fixed annuity&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Fixed annuities are a way to save money for retirement. The money you save is tax&#45;deferred like in an IRA or a 401(k) and you&#39;ll get a guaranteed minimum rate of return.<sup>1</sup> There are no investment options with fixed annuities, but you&#39;ll get fixed payments under the conditions you choose when you buy the annuity. There are no limits on non&#45;qualified contributions, and only your earnings are taxed when you make a withdraw. When you&#39;re ready to take your money out, you&#39;ll have a few options. You can convert it into a guaranteed, lifelong{' '}
                  <Link
                    id='fixed-variable-annuities-convert-fixed-to-lifelong-income-annuity-link'
                    linkUrl='/annuities/'
                    variant='primaryDeemphasize'
                    ariaLabel='Learn about converting annuities as part of a financial plan.'>
                    income annuity
                  </Link>, or you can take your money in one lump sum.{' '}
                  <Link
                    id='fixed-variable-annuities-find-out-more-about-different-types-of-annuities-link'
                    linkUrl='/life-and-money/what-are-the-different-types-of-annuities/'
                    variant='primaryDeemphasize'
                    ariaLabel='learn about the different types of annuities.'>
                    Find out more about the different types of annuities
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'fixed-variable-annuities-is-it-an-investment',
              title: <>Is an annuity <WidowBlock>an investment&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Variable annuities are considered investments. Fixed annuities are not. With a variable annuity, you can choose where your premiums are invested. Your annuity&#39;s rate of return is based on the performance of those investments. Variable annuity rates aren&#39;t guaranteed. But they have the potential for higher returns than a fixed annuity. Variable annuities, on the other hand, might go down in value, but fixed annuities will not.{' '}
                  <Link
                    id='fixed-variable-annuities-is-it-an-investment-link'
                    linkUrl='/life-and-money/is-an-annuity-an-investment-or-an-insurance-policy/'
                    variant='primaryDeemphasize'
                    ariaLabel='learn about annuities as investments.'>
                    Find out more about annuities as investments
                  </Link>.
                </Typography>
              ),
            },
            {
              id: 'fixed-variable-annuities-whats-the-difference',
              title: <>What&#39;s the difference between an indexed annuity and a <WidowBlock>fixed annuity&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Fixed and variable annuities are the two ends of a spectrum. There are other types of annuities that fall in between and include features of both fixed and variable annuities. An indexed annuity is one of them. It has the potential for growth, like a variable annuity. It also has a guaranteed minimum rate of return, like a fixed annuity. However, there are some drawbacks like longer surrender periods and less true market participation.
                </Typography>
              ),
            },
            {
              id: 'does-a-fixed-annuity-cost-the-same-as-a-variable-annuity',
              title: <>Does a fixed annuity cost the same as a <WidowBlock>variable annuity&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Fixed annuities often have higher minimum premiums and are generally funded with a single payment. Variable annuities generally have lower premiums and can be funded with either a single payment or ongoing contributions. The actual dollar amount you pay depends on your personal goals and situation.
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);

